export const MEDIA_WITH_SLIDES = ['pdf', 'presentation', 'imageSequence'] as const;

export const hasSlideSupport = (fileType?: string): boolean => {
  if (!fileType) return false;
  return (MEDIA_WITH_SLIDES as readonly string[]).includes(fileType);
};

export type SlideControlMediaType = 'presentation' | 'pdf' | 'imageSequence';

export const resolveSlideControlMediaType = (fileType?: string): SlideControlMediaType => {
  if (fileType === 'pdf') return 'pdf';
  if (fileType === 'imageSequence') return 'imageSequence';
  return 'presentation';
};
